export default __webpack_public_path__ + "static/media/blog-sealer-001.255dd869.jpg";